import MathUtils from '../math/MathUtils';
Math.approxEquals = MathUtils.approxEquals;
Math.div = MathUtils.div;
Math.ensureInRange = MathUtils.ensureInRange;
Math.ensurePositive = MathUtils.ensurePositive;
Math.floorEx = MathUtils.floor;
Math.isBetween = MathUtils.isBetween;
Math.map = MathUtils.map;
Math.maxEx = MathUtils.max;
Math.minEx = MathUtils.min;
Math.percent = MathUtils.percent;
Math.percentile = MathUtils.percentile;
Math.rescale = MathUtils.rescale;
Math.reversePercentile = MathUtils.reversePercentile;
Math.roundEx = MathUtils.round;
Math.roundToNearest = MathUtils.roundToNearest;
Math.wrap = MathUtils.wrap;
//# sourceMappingURL=MathExtensions.js.map